import Actions360 from "../components/GridTableUtils/Actions360";

export const columnsGroups360 = [
    {
        field: 'firstName',
        headerName: 'First Name',
        flex: 1
    },
    {
        field: 'lastName',
        headerName: 'Last Name',
        flex: 1
    },
    {
        field: 'email',
        headerName: 'Email',
        flex: 1
    },
    {
        field: 'status',
        headerName: 'Status',
        flex: 1
    },
    {
        field: 'actions',
        headerName: 'ACTIONS',
        flex: 1,
        renderCell: Actions360
    },
];